module.exports = __webpack_public_path__ + "img/ok.85111533.svg";